import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate, numberToLetter } from '../util';
import { Content, Component } from '../DataStructures';
export default function Row(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(Form, null, props.data.children.map((child, index) => {
    const letter = numberToLetter(index);
    return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Column ", letter)), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, props.data.children.length > 1 && /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove column",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        props.data.children.splice(index, 1);
        forceUpdate();
        props.onChanged();
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        let fullPath = props.path.slice();
        fullPath.push("children", index, "children");
        props.scopeToItem(fullPath);
      }
    }, "Edit Column ", letter), /*#__PURE__*/React.createElement("hr", null));
  }), /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "success",
    onClick: () => {
      props.data.children.push(new Component({
        tagName: 'Col',
        children: new Content(new Element({
          tagName: 'p',
          children: new Content("Lorem ipsum dolor sit amet")
        }))
      }));
      forceUpdate();
      props.onChanged();
    }
  }, "Add New Column"));
}